import { injectStrict } from '../../utils';
import { TOASTER_API } from './shared';
export function useToaster() {
  return injectStrict(TOASTER_API, undefined, 'useToaster was called with no installed Toaster');
}
